import { TDealershipSuggestion } from "../../types/dealerLocator.types";

export const fetchDealersByGeoCode = ({ lat, lng, pageId, language, countryIsoCode }, controllerRef) => {
    if (controllerRef.current) {
        controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;

    const queryUrlParams = new URLSearchParams({
        latitude: lat,
        longitude: lng,
        pageId: pageId,
        language: language,
        country: countryIsoCode,
    });
    const dealerFormGeoCodeApi = '/apirequest/formdealerlocator/get-dealer-by-geo-code';
    const queyrUrl = `${dealerFormGeoCodeApi}?${queryUrlParams}`;

    return fetch(queyrUrl, { signal: controllerRef.current?.signal }).then((res) => {
        if (res.ok) {
            return res.json();
        } else {
            console.error(`${res.status} : Failed to fetch dealers from DL API.`);
        }
    });
};

export const sortDealersByDistance = (dealers: TDealershipSuggestion[]): TDealershipSuggestion[] => {
    return dealers.sort((a, b) => Number.parseFloat(a?.distance ?? '') - Number.parseFloat(b?.distance ?? ''));
};